<template>
  <div class="item-container">
    <FriedAvatar
      class="avatar"
      :name="displayName(participant)"
      :thumb-url="participant.thumbUrl"
    />
    <div class="button-text">
      <strong
        >{{ participant.firstName }} {{ participant.lastName
        }}{{ formatTitleAndCompanyName(participant) }}</strong
      >
      <small>{{ participant.email }}</small>
    </div>
    <slot />
    <FriedIconButton
      v-if="showDeleteButton"
      v-tooltip="{
        content: t('dr_remove_participant_from_room'),
        delay: { show: 300, hide: 100 },
        placement: Placement.Top,
        offset: 8,
      }"
      class="delete-button"
      data-external="dsr-share-remove-participant-button"
      @click="$emit('remove', participant.email)"
    >
      <FriedIcon icon="close-circle" />
    </FriedIconButton>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import { AvatarHelper } from '@getaccept/lib-shared-new/src/helpers/avatars.helper';
import { ParticipantHelper } from '@getaccept/dsr-shared-new/src/helpers/participant.helper';
import { useI18n } from 'vue-i18n';
import { Placement } from '@getaccept/fried-tofu';
import type { Participant } from '../types';

export default defineComponent({
  props: {
    participant: {
      type: Object as PropType<Participant>,
      default: () => ({}),
    },
    showDeleteButton: {
      type: Boolean,
    },
  },
  emits: ['remove'],
  setup() {
    const { t } = useI18n();
    return {
      displayName: AvatarHelper.getDisplayName,
      formatTitleAndCompanyName: ParticipantHelper.formatTitleAndCompanyName,
      Placement,
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.item-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;

  .avatar {
    margin-right: var(--spacing-100);
  }

  .button-text {
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: $xs) {
    .delete-button {
      margin-left: auto;
    }
  }
}
</style>
